var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCasualD({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 17,
    viewBox: "0 0 20 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9731 0.01221L16.1576 0.224557C14.3585 0.432658 12.777 1.23321 11.5841 2.42235L8.74665 5.2625L6.49577 5.01565L3 8.50611L6.42676 8.93611C7.31331 11.1923 8.83424 12.7637 11.0586 13.5679L11.4939 17L14.9844 13.5042L14.7375 11.2534L17.5776 8.41586C18.7673 7.223 19.5673 5.64154 19.7723 3.87799L19.7754 3.84243L19.9878 2.02686C19.9958 1.96315 20 1.88989 20 1.81557C20 0.81276 19.1872 0 18.1844 0C18.1101 0 18.0363 0.00424695 17.9641 0.0132717L17.9731 0.01221ZM14.7614 7.15239C13.5887 7.15239 12.6379 6.20161 12.6379 5.02892C12.6379 3.85623 13.5887 2.90544 14.7614 2.90544C15.9341 2.90544 16.8849 3.85623 16.8849 5.02892C16.8849 5.0321 16.8849 5.03582 16.8849 5.03953C16.8849 6.21222 15.9341 7.16301 14.7614 7.16301V7.15239Z",
    fill: "#6B758B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.26088 14.8609C7.38319 14.2095 5.93074 12.7571 5.29317 10.924L5.27936 10.8794C5.27936 10.8794 3.01786 12.1163 3.76904 16.3606C8.01334 17.1091 9.26088 14.8609 9.26088 14.8609Z",
    fill: "#404D6A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCasualD);
export default __webpack_public_path__ + "static/media/casual-D.07cd278de8bf2218263d3da3433e6d8a.svg";
export { ForwardRef as ReactComponent };